import React from 'react'

export default props => (
  <svg
    width="8"
    height="6"
    viewBox="0 0 8 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.1038 0.589355C5.41797 0.589355 6.60363 1.12232 7.44301 1.97729L6.88508 2.51934C6.18878 1.80226 5.20027 1.35449 4.1038 1.35449C3.01439 1.35449 2.03156 1.79652 1.33601 2.50553L0.777344 1.96435C1.61596 1.11695 2.79628 0.589355 4.1038 0.589355ZM6.32724 3.06148C5.77413 2.48223 4.98279 2.11957 4.10401 2.11957C3.23271 2.11957 2.44737 2.47609 1.89496 3.04674L2.45387 3.58815C2.86299 3.15579 3.45082 2.88471 4.10401 2.88471C4.76511 2.88471 5.35925 3.16238 5.76892 3.6039L6.32724 3.06148ZM5.20931 4.14707C4.94369 3.84298 4.54682 3.64992 4.1034 3.64992C3.6683 3.64992 3.27803 3.8358 3.01259 4.13006L4.12133 5.20409L5.20931 4.14707Z"
      fill="white"
    />
  </svg>
)
